import { MediaFile } from "@models/mediaFile.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class MediaFileSerializer extends BaseSerializer {
  public deserialize(data: any): any {
    const gp = new MediaFile();
    this._copyAttributes(gp, data);
    return gp;
  }
}
